export default "__VITE_ASSET__D07M6s9W__"